import { render, staticRenderFns } from "./ArticlesUserLayout.vue?vue&type=template&id=434cb8b0&"
import script from "./ArticlesUserLayout.vue?vue&type=script&lang=js&"
export * from "./ArticlesUserLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports